module.exports = __webpack_public_path__ + "img/crossYearBanner.e1ed8f32.png";